// src/components/Toast.js
import React, { useEffect } from "react";
import "./Toast.css";

const Toast = ({ id, message, type = "info", duration = 5000, onClose }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose(id);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  const icons = {
    success: "✓",
    error: "✕",
    warning: "⚠",
    info: "ℹ",
  };

  const handleClose = () => {
    onClose(id);
  };

  return (
    <div
      className={`toast toast--${type}`}
      role="alert"
      aria-live={type === "error" ? "assertive" : "polite"}
      aria-atomic="true"
    >
      <div className="toast__content">
        <span className="toast__icon" aria-hidden="true">
          {icons[type]}
        </span>
        <span className="toast__message">{message}</span>
      </div>
      <button
        className="toast__close"
        onClick={handleClose}
        aria-label="Close notification"
        type="button"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
